const rightsData = (state) => state.rights;

export const rights = (state) => rightsData(state).rightsList;

export const rightsFetching = (state) => rightsData(state).fetching;

export const rightDescription = (state) => rightsData(state).rightDescription;
